import * as _ from 'lodash';
import * as log from 'loglevel';
import * as moment from 'moment-timezone';
import * as Cookies from 'js-cookie';
import {
  BookingDetails,
  DatesDisplay,
  HeroApiBookingProductAddon,
  PersonBooking,
  PriceDisplay,
  ProductSearch,
  SelectedRoom,
  PaymentState,
  Dates,
  Promo,
  Discount,
  GiftVoucher,
  StayVoucher
} from './models';

export const COOKIE_PRODUCT_SEARCH = 'productSearch';
export const COOKIE_SELECTED_ROOMS = 'selectedrooms';
export const COOKIE_ADDONS = 'addons';
export const COOKIE_PRICE_DISPLAY = 'priceDisplay';
export const COOKIE_DATES_DISPLAY = 'datesDisplay';
export const COOKIE_BOOKING_DETAILS = 'bookingdetails';
export const COOKIE_PERSON_BOOKING = 'personbooking';
export const COOKIE_DATES = 'dates';
export const COOKIE_PAYMENT_STATE = 'payment_state';
export const COOKIE_VISITOR_DEVICE_CLASS = 'visitorDeviceClass';
export const COOKIE_PROMOCODE = 'promoCode';
export const COOKIE_DISCOUNT = 'discCookie'
export const COOKIE_GIFTVOUCHER = 'giftVoucher';
export const COOKIE_STAYVOUCHER = 'stayVoucher';
export const COOKIE_FlexibleDates = 'flexibleDates';
export const TIME_ZONE_PREDEFINED = 'UTC';
export const TIME_ZONE_OFFSET = moment
  .tz(TIME_ZONE_PREDEFINED)
  .utcOffset();

if (__BUILD__) {
  console.log(__BUILD__);
}
log.setLevel(__DEV__ ? 'debug' : 'error');

export class Log {

  public static group = function (value) {
    if (__DEV__) {
      console.group(value);
    }
  };

  public static groupEnd = function () {
    if (__DEV__) {
      console.groupEnd();
    }
  };
}

if (__DEV__) {
  Log.group('Debug');

  log.debug('TIME_ZONE_PREDEFINED', TIME_ZONE_PREDEFINED);
  log.debug('TIME_ZONE_OFFSET', TIME_ZONE_OFFSET);

  log.debug(
    'Cookie - ' + COOKIE_PRODUCT_SEARCH,
    Cookies.getJSON(COOKIE_PRODUCT_SEARCH)
  );
  log.debug(
    'Cookie - ' + COOKIE_SELECTED_ROOMS,
    Cookies.getJSON(COOKIE_SELECTED_ROOMS)
  );
  log.debug('Cookie - ' + COOKIE_ADDONS, Cookies.getJSON(COOKIE_ADDONS));
  log.debug(
    'Cookie - ' + COOKIE_PRICE_DISPLAY,
    Cookies.getJSON(COOKIE_PRICE_DISPLAY)
  );
  log.debug(
    'Cookie - ' + COOKIE_DATES_DISPLAY,
    Cookies.getJSON(COOKIE_DATES_DISPLAY)
  );
  log.debug(
    'Cookie - ' + COOKIE_BOOKING_DETAILS,
    Cookies.getJSON(COOKIE_BOOKING_DETAILS)
  );
  log.debug(
    'Cookie - ' + COOKIE_PERSON_BOOKING,
    Cookies.getJSON(COOKIE_PERSON_BOOKING)
  );
  log.debug(
    'Cookie - ' + COOKIE_VISITOR_DEVICE_CLASS,
    Cookies.getJSON(COOKIE_VISITOR_DEVICE_CLASS)
  );
  log.debug(
    'Cookie - ' + COOKIE_PAYMENT_STATE,
    Cookies.getJSON(COOKIE_PAYMENT_STATE)
  );

  Log.groupEnd();
}

// set default time zone to AEST or AEST
Log.group('timezone');

moment.tz.setDefault(TIME_ZONE_PREDEFINED);

log.debug('set moment default time zone to ', TIME_ZONE_PREDEFINED);

Log.groupEnd();

class CookieVariable<T extends object> {
  private readonly name: string;

  constructor(name: string) {
    this.name = name;
  }

  public get(): T | undefined {
    return Cookies.getJSON(this.name);
  }

  public set(value: T): void {
    this.remove();
    Cookies.set(this.name, value);
  }

  public remove(): void {
    Cookies.remove(this.name);
  }
}

export const CookieCollection = {
  ProductSearch: new CookieVariable<ProductSearch>(COOKIE_PRODUCT_SEARCH),

  SelectedRooms: new CookieVariable<SelectedRoom[]>(COOKIE_SELECTED_ROOMS),

  Addons: new CookieVariable<HeroApiBookingProductAddon[]>(COOKIE_ADDONS),

  PriceDisplay: new CookieVariable<PriceDisplay>(COOKIE_PRICE_DISPLAY),

  DatesDisplay: new CookieVariable<DatesDisplay>(COOKIE_DATES_DISPLAY),

  BookingDetails: new CookieVariable<BookingDetails>(COOKIE_BOOKING_DETAILS),

  PersonBooking: new CookieVariable<PersonBooking>(COOKIE_PERSON_BOOKING),

  PaymentState: new CookieVariable<PaymentState>(COOKIE_PAYMENT_STATE),

  Dates: new CookieVariable<Dates>(COOKIE_DATES),

  PromoCode: new CookieVariable<Promo>(COOKIE_PROMOCODE),

  GiftVoucher: new CookieVariable<GiftVoucher>(COOKIE_GIFTVOUCHER),

  StayVoucher: new CookieVariable<StayVoucher>(COOKIE_STAYVOUCHER),

  FlexibleDates: new CookieVariable<Boolean>(COOKIE_FlexibleDates),

  DiscCookie: new CookieVariable<Discount>(COOKIE_DISCOUNT)

};

export const getUrlParameter = (sParam: string): string | undefined => {
  const sPageURL = decodeURIComponent(window.location.search.substring(1));
  const sURLVariables = sPageURL.split('&');
  let sParameterName;
  let i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] == sParam) {
      return sParameterName[1];
    }
  }

  return undefined;
};

/**
 * For first page, non-cookie based
 */

export const updateStayVouchers = () => {
       //STAY VOUCHERS
       let paxCount = 0;
       $('.roomwrapper').each(function() {
         const thisAdultCount = $(this)
           .find('.adultSelect')
           .val() as string;
         const thisChildCount = $(this)
           .find('.childSelect')
           .val() as string;
     
         paxCount += !thisAdultCount ? 0 : parseInt(thisAdultCount);
       //  paxCount += !thisChildCount ? 0 : parseInt(thisChildCount);
       });
       let vouchersRow = $('.stayvouchers');
       $(vouchersRow)
         .find('.stay')
         .each(function() {
           const itemNumber = $(this).data('count');
           if (itemNumber <= paxCount) {
             $(this).removeClass('d-none');
           } else {
             $(this).addClass('d-none');
           }
         });
       //STAY VOUCHERS
};

export const updateheaderCount = () => {
  let adultCount = 0;
  let childCount = 0;
  let roomCount = 0;
  $('.roomwrapper').each(function() {
    roomCount++;

    const thisAdultCount = $(this)
      .find('.adultSelect')
      .val() as string;
    const thisChildCount = $(this)
      .find('.childSelect')
      .val() as string;

    adultCount += !thisAdultCount ? 0 : parseInt(thisAdultCount);
    childCount += !thisChildCount ? 0 : parseInt(thisChildCount);
  });

  $('#adultCount').text(adultCount);
  $('#childCount').text(childCount);
  $('#roomCount').text(roomCount);

  updateStayVouchers();
};

/**
 * Error Popup
 *
 * @param {string} fg
 * @param {string} sl
 * @param {boolean} persist
 */
export const modalalert = (fg, sl, persist) => {
  $('#modalalert span').text(fg);
  // console.log(fg);
  const modal = $('#modalalert')
    .removeClass('error')
    .removeClass('success')
    .addClass(sl)
    .fadeIn();

  if (persist) {
    modal.on('click', () => {
      modal.fadeOut();
    });
  } else {
    modal.delay(3000).fadeOut();
  }
};

// Adults/Children/Rooms/Room Count
export const updateHeaderCounts = () => {
  const productSearch = CookieCollection.ProductSearch.get();

  if (productSearch) {
    let adultCount = 0;
    let childCount = 0;
    const rooms: number[] = [];
    let paxs = productSearch.paxs;
    if (!paxs) {
      paxs = [];
    }
    for (const pax of paxs) {
      if (pax.age == 18) {
        adultCount++;
      } else {
        childCount++;
      }

      rooms.push(pax.room);
    }

    const roomCount = _.reduce(rooms, (a, b) => {
      return Math.max(a, b);
    }) as number;

    $('#adultCount').text(adultCount);
    $('#childCount').text(childCount);
    $('#roomCount').text(roomCount);

    updateStayVouchers();

    if (roomCount == 1) {
      $('#accommodationSelect span').text(roomCount + ' Room');
    } else {
      $('#accommodationSelect span').text(roomCount + ' Rooms');
    }
  } else {
    $('#accommodationSelect span').text('');
  }
};

// Dates
export const updateHeaderDates = () => {
  const datesDisplay = CookieCollection.DatesDisplay.get();
  console.warn(' dates display ', datesDisplay);

  if (datesDisplay) {
    $('#datesofStay > span').hide();
    $('#datesofStay em').show();
    $('.clearmodaldates').text(datesDisplay.dates[0] + ' - ' + datesDisplay.dates[1]);
    $('#datesofStay .checkindatedisplay').text(datesDisplay.dates[0]);
    $('#datesofStay .checkoutdatedisplay').text(datesDisplay.dates[1]);
  } else {
    $('#datesofStay > span').show();
    $('#datesofStay em').hide();
  }
};

/**
 * Update header bar total price
 */
export const updateHeaderPrice = () => {
  Log.group('updateHeaderPrice');
  try {
    const selectedRooms = CookieCollection.SelectedRooms.get();
    const addons = CookieCollection.Addons.get();
    const calendarPricing = CookieCollection.PriceDisplay.get();
    const giftVoucher = CookieCollection.GiftVoucher.get();
    const stayVoucher = CookieCollection.StayVoucher.get();
    if (selectedRooms) {
      let price = 0;
      for (const room of selectedRooms) {
        price += room.price;
        log.debug('price', price);
      }

      if (addons) {
        for (const addon of addons) {
          const ap = addon.quantity * addon.price;
          price = price + ap;
          log.debug('addons price', ap);
        }
      }

      const priceFormatted = '$' + price.toFixed(2);
      $('#TotalCost span').text(priceFormatted);
      $('.mobileTotal').text(priceFormatted);
    } else {
      if (calendarPricing) {
        const price = calendarPricing.price;  
        $('#TotalCost span').text('From $' + price.toFixed(2));
        $('.mobileTotal').text('$' + price.toFixed(2));
      } else {
        log.debug('calendar pricing does not exist: ' + calendarPricing);
        $('#TotalCost span').text('From $0.00');
        $('.mobileTotal').text('$0.00');
      }
    }
    if (giftVoucher)
    {
      const voucherValue = giftVoucher.value;
      log.debug('gift voucher value: ' + giftVoucher.value);
      if (giftVoucher.value > 0)
      {
        $('#voucherValue').text('($' + voucherValue.toFixed(2) + ' Gift Credit)');
      }
    }
    if (stayVoucher)
    {
      const voucherValue = stayVoucher.value;
      log.debug('stay voucher value: ' + stayVoucher.value);
      if (stayVoucher.value > 0)
      {
        $('#voucherValue').text('($' + voucherValue.toFixed(2) + ' Stay Credit)');
      }
    }
  } finally {
    Log.groupEnd();
  }
};

export const updateRoomNumber = () => {
  let count = 0;
  $('.roomwrapper').each(function() {
    count++;
    // console.log(count)
    $(this).data('roomcount', '');
    $(this)
      .find('.roomno')
      .text(count);
  });
};

export const initialise = () => {
  $('#info-toggle').on('click', () => {
    $('#info-pane').toggleClass('active');
  });

  // run script when page unload
  window.onunload = () => {
    // clear checkout disable class
    $('#toCheckout').removeClass('disabled');
  };

  $('.modal').on('shown.bs.modal', () => {
    $('.fade-slider')
      .not('.slick-initialized')
      .slick({
        prevArrow:
          '<div class="arrow left"><i class="fa fa-angle-double-left"></i></div>',
        nextArrow:
          '<div class="arrow right"><i class="fa fa-angle-double-right"></i></div>'
      });
    $('.fade-slider-simple')
      .not('.slick-initialized')
      .slick({
        arrows: false,
        autoplay: true,
        autoplaySpeed: 1000,
        speed: 500,
        fade: true
      });
  });

  const clear = getUrlParameter('clear');

  if (clear == 'true') {
    // console.log('clearing');
    Cookies.remove('selectedrooms');
    Cookies.remove('productSearch');
    Cookies.remove('dates');
    Cookies.remove('addons');
    Cookies.remove('priceDisplay');
    Cookies.remove('datesDisplay');
    Cookies.remove('bookingdetails');
    Cookies.remove('personbooking');
    Cookies.remove('visitorDeviceClass');
    Cookies.remove('giftVoucher');
    Cookies.remove(COOKIE_PAYMENT_STATE);
    Cookies.remove('promoCode');
    Cookies.remove('discCookie');
    Cookies.remove('stayVoucher');
    updateHeaderDates();
    updateHeaderPrice();
    updateheaderCount();
    // console.log('done');
    // populate promo
    //const promoCode = CookieCollection.PromoCode.get();
    //if (promoCode && $('#PromoCode').val() == '')
   // {
  //    console.log('promo from cookie: ', promoCode.code);
    //  $('#PromoCode').val(promoCode.code);
   // }
    // populate giftVoucher
    const giftVoucher = CookieCollection.GiftVoucher.get();
    if (giftVoucher && $('#GiftVoucher').val() == '')
    {
      console.log('voucher from cookie: ', giftVoucher.code);
      $('#GiftVoucher').val(giftVoucher.code);
    }
  } else {
    updateHeaderCounts();
    updateHeaderDates();
    updateHeaderPrice();
  }

  if ($('.roomwrapper').length) {
    updateRoomNumber();
    updateheaderCount();
  }

  // apply red border to required field if the field is invalid
  $('.form-control:not(.optional)').on('change', function() {
    if (!$(this).val()) {
      $(this).addClass('invalid');
    } else {
      $(this).removeClass('invalid');
    }
  });

  // apply red border to required field if the field is invalid
  $('.form-check:not(.optional) input[type=checkbox]').on('change', function() {
    const $this = $(this);
    const $parent = $(this).parent('.form-check');
    if (!$this.is(':checked')) {
      $parent.addClass('invalid');
    } else {
      $parent.removeClass('invalid');
    }
  });
};

export function removeLastSegmentFromUrl(url: string) {
  var segments = url.split('/');
  segments.pop();
  return segments.join('/');
}

/*
  UI helpers
*/
export function showLoader() {
  $('#loader')
    .removeClass('hide')
    .show();
};

export function hideLoader() {
  $('#loader')
    .addClass('hide')
    .hide();
};

export function failedPayment (error, redirect) {
  let message = 'Failed to process request, please try again';
  message = error? `${message} (${error})`: message;
  modalalert(message, 'error', false);
  if (redirect === true)
    setTimeout(function () {
      window.location.reload();
    }, 3000);
}

/*
  End of UI helpers section
*/
